module.exports = __webpack_public_path__ + "h5/img/lottery-rule.c9e790c3.png";